export default "__VITE_ASSET__DUiLHTrT__"